const accessAsset = {

    ADD_ASSET: { name: 'Add GRN', path: '/add-grn' },
    UPDATE_ASSET: { name: 'Edit GRN', path: '/edit-grn' },
    ASSET_LIST: { name: 'GRN', path: '/grn-list' },
    STOCK_LIST: { name: 'Stock', path: '/stock-list' },
    GRN_DETAILS: { name: 'GRN Detail', path: '/grn-detail' },

    ADD_ASSET_ISSUE: { name: 'Add Asset Issue', path: '/add-asset-issue' },
    ASSET_ISSUE_DETAILS: { name: 'Asset Issue Detail', path: '/asset-issue-detail' },
    ASSET_ISSUE_LIST: { name: 'Asset Issue', path: '/asset-issue-list' },
    QR_CODE_ISSUE: { name: 'QR Code Issue', path: '/qr-code-issue' },

    AMC_LIST: { name: 'AMC', path: '/amc-list' },
    ADD_AMC: { name: 'Add AMC', path: '/add-amc' },
    UPDATE_AMC: { name: 'Edit AMC', path: '/edit-amc' },
    AMC_DETAILS: { name: 'AMC Detail', path: '/amc-detail' },
    DELETE_AMC: { name: 'Delete AMC', path: '/delete-amc' },


    ASSET_DETAILS: { name: 'Asset Detail', path: '/asset-detail' },
    ADD_WARRANTY: { name: 'Add Warranty', path: '/add-warranty' },
    QR_CODE_STOCK: { name: 'QR Code Stock', path: '/qr-code-stock' },

    ADD_INVENTORY: { name: 'Add Barcode', path: '/add-barcode' },

    ASSET_LOCATION: {
        path: '/asset-location'
    },
    ASSET_LOCATION_DETAILS: {
        path: '/asset-location-details'
    },



}

export default accessAsset;